<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
        <div class="d-sm-flex align-items-center mt-10 mt-lg-0">
          <h5 class="card-title fw-bold mb-0">User Level</h5>
        </div>
        <!-- <div class="d-sm-flex align-items-center mt-10 mt-lg-0">
          <form class="search-box position-relative" @submit.prevent="handleSearch">
            <input type="text" class="form-control shadow-none text-black rounded-0 border-0" placeholder="Search integration"
              v-model="searchQuery" />
            <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
              <i class="flaticon-search-interface-symbol"></i>
            </button>
          </form>
          <select class="project-select form-select shadow-none fw-semibold rounded-1 mt-10 mt-sm-0 ms-sm-10" v-model="pageSize" @change="fetchIntegrations(searchQuery)">
            <option :value="5">5</option>
            <option :value="10">10</option>
            <option :value="25">25</option>
            <option :value="50">50</option>
          </select>
        </div> -->
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive" style="overflow: visible;">
          <table class="table text-nowrap align-middle mb-0">
            <colgroup>
              <col style="width: 25%;">
              <col style="width: 25%;">
              <col style="width: 25%;">
              <col style="width: 25%;">
              <col style="width: 0%;">
            </colgroup>
            <thead>
              <tr>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Provider
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Account
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Status
                </th>
                <!-- <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  Action
                </th> -->
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Action
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="integration in filteredIntegrations" :key="integration.id">
                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ integration.providerName }}
                </th>
                
                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ integration.account }}
                </th>

                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ integration.isConnected ? 'Connected' : 'Disconnected' }}
                </th>

                <td class="shadow-none lh-1 fw-medium text-end pe-0">
                  <a v-if="!integration.isConnected" class="dropdown-item d-flex align-items-center" :href="integration.signInUrl">
                    <i class="flaticon-edit lh-1 me-8 position-relative top-1"></i>
                    Sign In
                  </a>

                  <a v-else class="dropdown-item d-flex align-items-center" href="#" @click.prevent="deleteIntegration(integration.id)">
                    <i class="flaticon-edit lh-1 me-8 position-relative top-1"></i>
                    Sign Out
                  </a>
                </td>

                <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" >
                  
                </td>
                
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
          <p class="mb-0 text-paragraph">
            Showing <span class="fw-bold">{{ filteredIntegrations.length }}</span> out of
            <span class="fw-bold">{{ totalIntegrations }}</span> results
          </p>
          <!-- <nav class="mt-15 mt-md-0">
            <ul class="pagination mb-0">
              <li class="page-item" :class="{ disabled: pageIndex === 1 }">
                <a class="page-link" href="#" aria-label="Previous" @click.prevent="changePage(pageIndex - 1)">
                  <i class="flaticon-chevron-1"></i>
                </a>
              </li>
              <li class="page-item" v-for="page in totalPages" :key="page" :class="{ active: page === pageIndex }">
                <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
              </li>
              <li class="page-item" :class="{ disabled: pageIndex === totalPages }">
                <a class="page-link" href="#" aria-label="Next" @click.prevent="changePage(pageIndex + 1)">
                  <i class="flaticon-chevron"></i>
                </a>
              </li>
            </ul>
          </nav> -->
        </div>
      </div>
    </div>

    <div v-if="this.currentPermissions?.includes('platformIntegration.read')" class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
        <div class="d-sm-flex align-items-center mt-10 mt-lg-0">
          <h5 class="card-title fw-bold mb-0">System Level</h5>
        </div>
        <!-- <div class="d-sm-flex align-items-center mt-10 mt-lg-0">
          <form class="search-box position-relative" @submit.prevent="handleSearch">
            <input type="text" class="form-control shadow-none text-black rounded-0 border-0" placeholder="Search platform integration"
              v-model="searchQuery" />
            <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
              <i class="flaticon-search-interface-symbol"></i>
            </button>
          </form>
          <select class="project-select form-select shadow-none fw-semibold rounded-1 mt-10 mt-sm-0 ms-sm-10" v-model="pageSize" @change="fetchPlatformIntegrations(searchQuery)">
            <option :value="5">5</option>
            <option :value="10">10</option>
            <option :value="25">25</option>
            <option :value="50">50</option>
          </select>
        </div> -->
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive" style="overflow: visible;">
          <table class="table text-nowrap align-middle mb-0">
            <colgroup>
              <col style="width: 25%;">
              <col style="width: 25%;">
              <col style="width: 25%;">
              <col style="width: 25%;">
              <col style="width: 0%;">
            </colgroup>
            <thead>
              <tr>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Provider
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Account
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Status
                </th>
                <!-- <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  Action
                </th> -->
                <th v-if="this.currentPermissions?.includes('platformIntegration.manage')" scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Action
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="integration in filteredPlatformIntegrations" :key="integration.id">
                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ integration.providerName }}
                </th>
                
                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ integration.account }}
                </th>

                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ integration.isConnected ? 'Connected' : 'Disconnected' }}
                </th>

                <td v-if="this.currentPermissions?.includes('platformIntegration.manage')" class="shadow-none lh-1 fw-medium text-end pe-0">
                  <a v-if="!integration.isConnected" class="dropdown-item d-flex align-items-center" :href="integration.signInUrl">
                    <i class="flaticon-edit lh-1 me-8 position-relative top-1"></i>
                    Sign In
                  </a>

                  <a v-else class="dropdown-item d-flex align-items-center" href="#" @click.prevent="deleteIntegration(integration.id)">
                    <i class="flaticon-edit lh-1 me-8 position-relative top-1"></i>
                    Sign Out
                  </a>
                </td>
                <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" >
                  <div class="dropdown" >
                    <button class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button"
                      data-bs-toggle="dropdown" aria-expanded="false"> 
                      <i class="flaticon-dots"></i>
                    </button>
                    <ul class="dropdown-menu" >
                      <li>
                        <a @click.prevent="goToQwilrInfo()" class="dropdown-item d-flex align-items-center" href="#" >
                          <i class="flaticon-settings lh-1 me-8 position-relative top-1"></i>
                          Setup Definitions
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
          <p class="mb-0 text-paragraph">
            Showing <span class="fw-bold">{{ filteredIntegrations.length }}</span> out of
            <span class="fw-bold">{{ totalPlatformIntegrations }}</span> results
          </p>
          <!-- <nav class="mt-15 mt-md-0">
            <ul class="pagination mb-0">
              <li class="page-item" :class="{ disabled: pageIndex === 1 }">
                <a class="page-link" href="#" aria-label="Previous" @click.prevent="changePage(pageIndex - 1)">
                  <i class="flaticon-chevron-1"></i>
                </a>
              </li>
              <li class="page-item" v-for="page in totalPages" :key="page" :class="{ active: page === pageIndex }">
                <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
              </li>
              <li class="page-item" :class="{ disabled: pageIndex === totalPages }">
                <a class="page-link" href="#" aria-label="Next" @click.prevent="changePage(pageIndex + 1)">
                  <i class="flaticon-chevron"></i>
                </a>
              </li>
            </ul>
          </nav> -->
        </div>
      </div>
    </div>

    <QwilrDataSource v-if="this.currentPermissions?.includes('platformIntegration.read')"></QwilrDataSource>

  </template>
  
  <script>
  import { GetAllIntegrations, SignOutIntegration, GetAllPlatformIntegrations } from '@/core/services/entities/integrations.service'
  import { useToast } from 'vue-toastification'
  import Swal from 'sweetalert2';
  import { mapGetters} from 'vuex'
  import breadcrumbMixin from '@/mixins/BreadcrumbMixin';
  import QwilrDataSource from '@/components/Qwilr/QwilrDataSource.vue';

  export default {
    name: "IntegrationList",
    components: {
      QwilrDataSource
    },
    data() {
      return {
        integrations: [], 
        searchQuery: "", 
        filteredIntegrations: [], 
        filteredPlatformIntegrations: [], 
        pageSize: 10, 
        pageIndex: 1, 
        totalIntegrations: 0, 
        totalPlatformIntegrations: 0, 
        totalPages: 1, 
        showUpdateLightbox : false,
        selectedRole : {}
      };
    },
    mixins: [breadcrumbMixin],
    methods: {
      async fetchIntegrations(filter = "") {
        let data = await GetAllIntegrations();
        if(data)
        {
          this.filteredIntegrations = data.integrations;
          this.totalIntegrations = data.integrations.length;
        }

      },
      async fetchPlatformIntegrations(filter = "") {
        let data = await GetAllPlatformIntegrations();
        if(data)
        {
          this.filteredPlatformIntegrations = data.platformIntegrations;
          this.totalPlatformIntegrations = data.platformIntegrations.length;
        }

      },
      handleSearch(event) {
        event.preventDefault();
        const filter = this.searchQuery.trim();
        this.pageIndex = 1; 
        this.fetchIntegrations(filter);
      },
      changePage(page) {
        if (page > 0 && page <= this.totalPages) {
          this.pageIndex = page;
          this.fetchIntegrations(this.searchQuery);
        }
      },
      async deleteIntegration(integrationId) {
        const toast = useToast();

        // Show confirmation dialog using SweetAlert2
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sign out!'
        }).then(async (result) => {  
          if (result.isConfirmed) {
            try {
              const payload = { id: integrationId };
              let response = await SignOutIntegration(payload);  
              if (response.status === 200) {
                toast.success('Integration sign out successfully!', {
                  timeout: 2000,
                });
                this.fetchIntegrations();
              }
            } catch (ex) {
              const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
              toast.error(`Failed to sign out: ${errorMessage}`, {
                timeout: 2000,
              });
            }
          } else {
            toast.info('Integration sign out canceled.', { timeout: 2000 });
          }
        });

      },
      openUpdateLightbox (role){
        this.selectedRole = role;
        this.showUpdateLightbox = true;
      },
      closeUpdateLightbox(){
        this.showUpdateLightbox = false;
      },
      handleDataStreamUpdated(){
        this.closeUpdateLightbox();
        // fetchDataStreams(searchQuery.value);
      },
      async goToQwilrInfo() {
        this.$router.push({ name: 'qwilrInfoPage'});
      }
    },
    computed:{...mapGetters(['allowAdd', 'currentPermissions'])},
    created() {
      this.fetchIntegrations();
      this.fetchPlatformIntegrations();
    }
  };
  </script>


  